import { paths } from './paths';

/**
 * Top-level URL prefixes that are considered part of the admin dashboard layout.
 */
const adminPathPrefixes = [paths.members, paths.applicants, paths.applications] as const;

/**
 * Checks if a given URL pathname is part of the admin section.
 */
export const isAdminPath = (pathname: string): boolean => {
	return adminPathPrefixes.some((prefix) => pathname.startsWith('/' + prefix.split('/')[1]));
};

export type PathParams = Record<string, string | number | undefined>;

/**
 * Replaces `:param` segments in a route template with values from `params`.
 */
export const generatePath = (path: string, params: PathParams = {}): string => {
	let finalPath = path;
	for (const [key, value] of Object.entries(params)) {
		if (value !== undefined) {
			finalPath = finalPath.replace(`:${key}`, String(value));
		}
	}
	return finalPath;
};
